import { render, staticRenderFns } from "./RsaPazienteAreeComponent.vue?vue&type=template&id=14cceab5&scoped=true"
import script from "./RsaPazienteAreeComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteAreeComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazienteAreeComponent.vue?vue&type=style&index=0&id=14cceab5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cceab5",
  null
  
)

export default component.exports